import { render, staticRenderFns } from "./PurchasePreventAlert.vue?vue&type=template&id=1ae940b6&scoped=true"
import script from "./PurchasePreventAlert.vue?vue&type=script&lang=js"
export * from "./PurchasePreventAlert.vue?vue&type=script&lang=js"
import style0 from "./PurchasePreventAlert.vue?vue&type=style&index=0&id=1ae940b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae940b6",
  null
  
)

export default component.exports